import React from "react";
import styled from "styled-components";
import BlockSection from "../../components/BlockSection/Block.component";
import BlockDescription from "../../components/BlockDescription/BlockDescription.component";
import dietJPG from "./../../assets/img/diet.jpg";
import healthJPG from "./../../assets/img/health.jpg";
import childrenJPG from "./../../assets/img/children.jpg";
import healthFoodIcon from "./../../assets/img/icons/health_food.png";
import wateringIcon from "./../../assets/img/icons/watering.png";
import softeningIcon from "./../../assets/img/icons/softening.png";
import healthKidIcon from "./../../assets/img/icons/health_kid.png";
import healthIconsIcon from "./../../assets/img/icons/icons_health.png";
import offlineIcon from "./../../assets/img/icons/offline.png";
import activityIcon from "./../../assets/img/icons/activity.png";
import creativityIcon from "./../../assets/img/icons/creativity.png";
import timeIcon from "./../../assets/img/icons/time.png";

const BlocksWrapper = styled.main`
    display: grid;
    width: 100%;
    height: auto;
    grid-template-columns: minmax(1fr, 970px);

    /* @media screen and (max-width: 830px) {
        grid-template-columns: 1fr;
        padding: 0 40px;
        grid-auto-rows: auto;
    } */
`;

const AboutUsPage = (props) => (
    <BlocksWrapper>
        <h1 className="big center">O czym piszemy:</h1>

        <BlockSection
            id="dzialy"
            img={dietJPG}
            title="dobra dieta"
            floatingTitle="dieta"
            inverted
        >
            <ul>
                <li>
                    <p>Jak radzić sobie z problemami żywieniowymi u dzieci? </p>
                </li>
                <li>
                    <p>
                        Jakich składników i w jakich ilościach dostarczać, żeby
                        prawidłowo bilansować dietę dziecka?{" "}
                    </p>
                </li>
                <li>
                    <p>Co robić, żeby przekonać dziecko do zdrowych nawyków?</p>
                </li>
                <li>
                    <p>Jak wspierać naturalną odporność?</p>
                </li>
            </ul>
            <p>
                W tym dziale znajdziesz rzetelne odpowiedzi ekspertów na
                wątpliwości dotyczące prawidłowego żywienia dzieci. Poznasz
                sposoby na świadome i jednocześnie atrakcyjne sposoby
                komponowania diety dziecka.
            </p>
        </BlockSection>
        <BlockDescription
            iconOne={healthFoodIcon}
            iconTwo={wateringIcon}
            iconThree={healthKidIcon}
        >
            <p>
                <b>W najbliższych wydaniach</b> przeczytasz:
            </p>
            <ul>
                <li>
                    <p>Zdrowe wakacyjne przekąski</p>
                </li>
                <li>
                    <p>Czy woda wodzie równa?</p>
                </li>
                <li>
                    <p>Oleje w dziecięcej diecie</p>
                </li>
                <li>
                    <p>Moc odporności, jak ją zdobyć</p>
                </li>
                <li>
                    <p>Wartościowy lunchbox</p>
                </li>
                <li>
                    <p>Jak dobrze zbilansować dietę niejadka</p>
                </li>
            </ul>
        </BlockDescription>
        <BlockSection
            img={healthJPG}
            title="sposoby na zdrowie"
            floatingTitle="ZDROWIE"
        >
            <ul>
                <li>
                    <p>Jak rozpoznać chorobę pasożytniczą u dziecka?</p>
                </li>
                <li>
                    <p>Jakie preparaty należy mieć w domowej apteczce?</p>
                </li>
                <li>
                    <p>Jak złagodzić objawy alergiczne u dziecka?</p>
                </li>
                <li>
                    <p>Co poradzić na nocny kaszel malucha?</p>
                </li>
            </ul>
            <p>
                Poszukiwanie odpowiedzi na niepokojące symptomy u dziecka, jak i
                troska o to, żeby nie przeoczyć ewentualnych oznak chorobowych
                to nasza rodzicielska codzienność. W tym dziale w przystępnej i
                skondensowanej formule wyjaśniamy, jak radzić sobie z chorobami
                i dolegliwościami naszych pociech. Znajdziesz tutaj rzetelne
                omówienia jednostek chorobowych, skuteczne sposoby domowego
                leczenia oraz porady, kiedy wizyta u lekarza może być konieczna.
            </p>
        </BlockSection>
        <BlockDescription
            inverted
            iconOne={healthIconsIcon}
            iconTwo={softeningIcon}
            iconThree={activityIcon}
        >
            <p>
                <b>W najbliższych wydaniach</b> przeczytasz:
            </p>
            <ul>
                <li>
                    <p>Pomocy, alergia!</p>
                </li>
                <li>
                    <p>Podróżna apteczka na rodzinne wyjazdy</p>
                </li>
                <li>
                    <p>Bzz, bzz, sposoby na ukąszenia</p>
                </li>
                <li>
                    <p>Mamo to boli – preparaty na wakacyjne kontuzje</p>
                </li>
                <li>
                    <p>Czy opalanie może być zdrowe</p>
                </li>
                <li>
                    <p>Basenowa woda zdrowia nie doda</p>
                </li>
                <li>
                    <p>Mycie ząbków to nie wszystko</p>
                </li>
                <li>
                    <p>Aaa psik! Na pomoc w przeziębieniu</p>
                </li>
                <li>
                    <p>Nieproszeni goście… na głowie</p>
                </li>
                <li>
                    <p>Uwaga! Ospa</p>
                </li>
            </ul>
        </BlockDescription>
        <BlockSection
            img={childrenJPG}
            title="razem z dzieckiem"
            floatingTitle="dziecko"
            inverted
        >
            <ul>
                <li>
                    <p>
                        W co się bawić, żeby rozwijać kompetencje kluczowe u
                        dziecka?
                    </p>
                </li>
                <li>
                    <p>Czy szczęścia można się nauczyć?</p>
                </li>
                <li>
                    <p>Jak planować wspólny czas bez nadmiaru ekranów?</p>
                </li>
                <li>
                    <p>Czego potrzebuje dziecięcy mózg?</p>
                </li>
            </ul>
            <p>
                Odpowiemy nie tylko na te, ale i wiele innych pytań związanych z
                rozwojem społeczno-emocjonalnym dzieci. Poznasz wartościowe
                zabawy i aktywności, które wspierają rozwój motoryczny i
                intelektualny malucha. Sporą uwagę poświęcimy budowaniu
                kompetencji czytelniczych i językowych. Podpowiemy także, jak
                rozmawiać i jak promować pozytywne nastawienie i samorozwój u
                dziecka.
            </p>
        </BlockSection>
        <BlockDescription
            iconOne={offlineIcon}
            iconTwo={creativityIcon}
            iconThree={timeIcon}
        >
            <p>
                <b>W najbliższych wydaniach</b> przeczytasz:
            </p>
            <ul>
                <li>
                    <p>Szczęście można wyćwiczyć</p>
                </li>
                <li>
                    <p>Czas bez ekranów, jak to zrobić</p>
                </li>
                <li>
                    <p>Zabawy na pogodę i niepogodę</p>
                </li>
                <li>
                    <p>Akcja adaptacja</p>
                </li>
                <li>
                    <p>Nastawienie na rozwój – co to znaczy</p>
                </li>
                <li>
                    <p>Aktywności wzmacniające poczucie własnej wartości</p>
                </li>
            </ul>
        </BlockDescription>
    </BlocksWrapper>
);
export default AboutUsPage;
